export default "__VITE_ASSET__JRHVdZ0a__"